import RGSProvider from './RGS/RGSProvider';
import { Settings } from './settings';

const RGS = await RGSProvider.loadProvider(Settings.APP.RGS_PROVIDER);

export const handleInitGame = async () => {
  return await RGS.initGame();
};

export const handleSpin = async (bet, token) => {
  return await RGS.spin(bet, token);
};

export const handleSimulate = async (slotface, bet, token) => {
  return await RGS.simulate(slotface, bet, token);
};
